var map = {
	"./quickStart/apiService.mp4": 51248,
	"./quickStart/dashboard.mp4": 69297,
	"./quickStart/dataCloud.mp4": 76487,
	"./quickStart/start.mp4": 50537,
	"./quickStart/welcome.mp4": 31643
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79335;